import { Link } from "react-router-dom";
import { PageHeader } from "./ui";

const TOPICS = [
  ["acesso", "Acessar o painel", "/admin", [
    "Abra o endereço do ZAP IUDP e acrescente /admin no final (exemplo: seusite.com.br/admin).",
    "Entre com o e-mail do Administrador Geral e a senha. Na primeira vez, use “Criar conta” com esse mesmo e-mail e confirme o código recebido por e-mail.",
    "Para sair, toque em “Sair” no menu do painel.",
  ]],
  ["participantes", "Consultar participantes", "/admin/participantes", [
    "Menu Participantes: lista com nome, WhatsApp, cidade e estado.",
    "Use a busca para procurar por nome, WhatsApp, cidade ou estado.",
    "Toque em um nome para abrir a conversa e os dados completos da pessoa.",
  ]],
  ["mensagens", "Visualizar mensagens", "/admin/conversas", [
    "Menu Conversas mostra todas as participações, as mais recentes primeiro.",
    "Os atalhos Pedidos de oração, Fotografias, Testemunhos, Solicitações Deus Proverá e Outras mensagens filtram pela classificação.",
    "Ao abrir uma conversa, a situação passa de Recebido para Visualizado.",
    "Se a classificação estiver errada, corrija-a na própria mensagem.",
  ]],
  ["responder", "Responder atendimentos", "/admin/conversas", [
    "Dentro da conversa, escreva a resposta ou escolha uma resposta pronta. {primeiro_nome} vira o primeiro nome da pessoa.",
    "“No ZAP IUDP”: a pessoa vê a resposta na própria conversa do site.",
    "“Pelo WhatsApp”: abre o WhatsApp da pessoa com a mensagem pronta. Depois de enviar, volte e marque “Envio realizado”. O sistema não envia sozinho.",
    "Em Conversas, “PREPARAR PRÓXIMOS CINCO” organiza até cinco atendimentos pendentes para revisar um de cada vez.",
  ]],
  ["respostas", "Cadastrar respostas prontas", "/admin/respostas", [
    "Menu Biblioteca de respostas, aba “Respostas”.",
    "Preencha o formulário “Nova resposta”: escolha a categoria, escreva o texto e salve. Você pode editar, desativar, reativar ou excluir quando quiser.",
  ]],
  ["audios", "Cadastrar áudios oficiais", "/admin/respostas", [
    "Na Biblioteca de respostas, aba “Áudios oficiais”, envie um áudio gravado de verdade.",
    "Dê um título e associe a uma categoria. O sistema não cria nem imita vozes.",
  ]],
  ["pix", "Alterar o Pix", "/admin/pix", [
    "Configurações → Pix e marca.",
    "Escolha o tipo e informe a chave Pix, o favorecido e a cidade do favorecido e salve. O código copia e cola e o QR Code são gerados automaticamente.",
  ]],
  ["comprovantes", "Conferir comprovantes", "/admin/comprovantes", [
    "Menu Comprovantes Pix mostra os arquivos enviados pelos participantes.",
    "Confira no extrato bancário da igreja e marque “Conferido” ou “Divergente”. Quem conferiu fica registrado.",
    "Um comprovante enviado não é confirmação bancária automática.",
  ]],
  ["relatorios", "Consultar relatórios", "/admin/relatorios", [
    "Menu Relatórios. Escolha o período: Hoje, Ontem, Últimos 7 dias, Últimos 30 dias ou Personalizado.",
    "As abas mostram Indicadores, Participantes, Localidade, Origem e Atendimento.",
    "Na aba Origem estão os links de divulgação para Instagram, YouTube, site e campanhas.",
  ]],
  ["transmissoes", "Enviar para várias pessoas (Transmissões)", "/admin/transmissoes", [
    "Menu Transmissões → “Novo grupo”. Dê um nome e escolha quem recebe: todos, por estado, cidade, assunto já enviado, origem, ou pessoas específicas.",
    "O número de pessoas que vão receber aparece na hora, antes de salvar.",
    "Escolha o grupo, escreva a mensagem (ou use uma resposta pronta e/ou um áudio oficial) e toque em “Enviar para N pessoas”.",
    "Cada pessoa recebe na própria conversa, com o primeiro nome. Ninguém vê quem mais está no grupo. Quem ativou os avisos recebe notificação no celular.",
    "Em “Envios deste grupo” você vê quantas pessoas receberam e quantas já viram.",
  ]],

  ["exportar", "Exportar dados", "/admin/relatorios", [
    "Em Relatórios, “Baixar Excel” gera uma planilha com todas as abas do período escolhido.",
    "Nas abas Participantes e Localidade, “Planilha” baixa um arquivo CSV.",
    "Em Configurações, “Baixar cópia de segurança” gera um arquivo completo dos registros. Guarde-o em local seguro, porque ele contém dados pessoais.",
  ]],
];

export default function Help() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader title="Ajuda" description="Passo a passo para usar o painel." />
      <div className="scroll-thin min-h-0 flex-1 overflow-y-auto">
        <div className="max-w-3xl space-y-8 px-5 py-6 md:px-8">
          <nav className="flex flex-wrap gap-2" aria-label="Tópicos">
            {TOPICS.map(([id, t]) => <a key={id} href={`#${id}`} className="rounded-md bg-zap-mist px-3 py-1.5 text-sm font-medium hover:bg-zap-line">{t}</a>)}
          </nav>
          {TOPICS.map(([id, t, to, steps]) => (
            <section key={id} id={id} data-testid={`help-${id}`} className="scroll-mt-4 space-y-3 border-t border-zap-line pt-6">
              <div className="flex items-baseline justify-between gap-3">
                <h2 className="font-display text-lg font-semibold">{t}</h2>
                <Link to={to} className="shrink-0 text-sm font-semibold text-zap-green hover:underline">Abrir</Link>
              </div>
              <ol className="list-decimal space-y-1.5 pl-5 text-[15px] leading-relaxed">{steps.map((s) => <li key={s}>{s}</li>)}</ol>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
